import { render, staticRenderFns } from "./ExchangeRate.vue?vue&type=template&id=6f5cde51"
import script from "./ExchangeRate.vue?vue&type=script&lang=js"
export * from "./ExchangeRate.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/admin/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ExchangeRate.vue?vue&type=style&index=1&id=6f5cde51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports